export default "__VITE_ASSET__7034a9ce__"